import React, { Component } from "react";
import { connect } from "react-redux";
import {
  postPlanningSimple,
  getPlanningSimple,
} from "../les-tabs-ducks/Planning.ducks";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "../../../../../../src/main.scss";
import moment from "moment";
import _ from "lodash";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;
class Planning extends Component {
  calendarComponentRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      calendarWeekends: true,
      calendarEvents: [],
      nextEventAbsence: {},
      nextAbsence: {},
      initialized: false,
      currentAbsence: {},
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.dataPlanning !== this.props.dataPlanning) {
      let dataPlanning = this.props.dataPlanning;
      if(dataPlanning) {
        dataPlanning.absences = dataPlanning.absences.sort((a,b) => moment(a.dateTimeDebut).unix() - moment(b.dateTimeDebut).unix())
      }
      var listevents = [];
      if (!_.isEmpty(dataPlanning) && !_.isEmpty(dataPlanning.absences)) {
        let nextAbsence = dataPlanning.absences.find((element) =>
          moment().isBefore(element.dateTimeDebut)
        );
        let currentAbsence = dataPlanning.absences.find((element) =>
          moment().isBetween(element.dateTimeDebut, element.finSeance)
        );
        dataPlanning.absences.map((Events) => {
          if (!_.isEmpty(Events) && !_.isEmpty(Events.dateTimeDebut)) {
            var objectEvent = { textColor: "white" };
            objectEvent.title = Events.commentaire;
            objectEvent.start = moment(Events.dateTimeDebut).format();
            objectEvent.end = moment(Events.finSeance).format();
            objectEvent.id = Events.id;
            listevents.push(objectEvent);
          }
        });
        this.setState({ calendarEvents: listevents, nextAbsence: nextAbsence, currentAbsence: currentAbsence });
      } else {
        this.setState({ calendarEvents: [], nextAbsence: {}, currentAbsence: {} });
      }
    }
  }
  componentDidMount() {
    let str = window.location.pathname;

    let matches = str.match(/(\d+)/);
    this.props.getPlanningSimple(localStorage.getItem("token"), matches[0]);
  }

  toggleWeekends = () => {
    this.setState({
      calendarWeekends: !this.state.calendarWeekends,
    });
  };
  handleClick = (info) => {
    let obj = {
      start: info.event._instance.range.start,
      end: info.event._instance.range.end,
      id: info.event.id,
      events: this.state.calendarEvents
    };
    this.props.toUpdateEvent("absence-tab", null, obj);
  };
  handleDateClick = (info) => {
    let dateStartEnd = {
      start: info.date,
      end: info.date
    };
    this.props.editAbscence(dateStartEnd);
    console.log(info)
  }
  render() {
    return (
      <div
        className="tab-pane show active "
        id="planning-pane"
        role="tabpanel"
        aria-labelledby="planning-tab"
      >
        {this.props.loading ? (
          <div className="content p-0">
            <DotLoader
              size={100}
              color={"#ff7d26"}
              css={override}
              loading={this.props.loading}
            />
          </div>
        ) : (
          <div className="content p-0">
            <section className="content-section border-0 mb-0">
              <div className="text-center">
                { !_.isEmpty(this.state.currentAbsence) ? 
                ( <div className="btn-white btn-border mb-4"> Absent jusqu'au : {moment(this.state.currentAbsence.finSeance).format(
                  "DD/MM/YYYY")} </div>)
                :
                !_.isEmpty(this.state.nextAbsence) ? (
                  <div className="btn-white btn-border mb-4">
                    Prochaine absence du{" "}
                    {!_.isEmpty(this.state.nextAbsence)
                      ? moment(this.state.nextAbsence.dateTimeDebut).format(
                        "DD/MM/YYYY"
                      )
                      : ""}{" "}
                    au{" "}
                    {!_.isEmpty(this.state.nextAbsence)
                      ? moment(this.state.nextAbsence.finSeance).format(
                        "DD/MM/YYYY"
                      )
                      : ""}
                  </div>
                ) : (
                  <div className="btn-white btn-border mb-4">
                    Pas d'absence prévue
                  </div>
                )}
              </div>
              <div id="calendar">
                <FullCalendar
                  displayEventTime="false"
                  defaultView="dayGridMonth"
                  locale="fr"
                  style={"font-size: 0em;"}
                  header={{
                    left: "prev",
                    center: "title",
                    right: "next",
                  }}
                  plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                  ref={this.calendarComponentRef}
                  events={this.state.calendarEvents}
                  dateClick={this.handleDateClick}
                  eventClick={this.handleClick}
                />
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  loading: state.ficheEnfant.Planning.loading,
});
export default connect(mapStateToProps, {
  postPlanningSimple,
  getPlanningSimple,
})(Planning);
